/**
 * Created by AMER\jcid on 11/2/17.
 */

$(document).ready(function () {
  var isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (window.location.hash && isChrome) {
    setTimeout(function () {
      var hash = window.location.hash.replace('/', '');
      window.location.hash = '';
      window.location.hash = hash;
    }, 900);
  }
});
